import { MultiValueProps, components as ReactSelectComponents } from 'react-select';
import { IOptionParentIssuer } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IParent';

const MultiValueParentIssuerList = ({
  children,
  ...otherProps
}: MultiValueProps<IOptionParentIssuer>) => (
  <ReactSelectComponents.MultiValue { ...otherProps }>
    { `${ otherProps.data.label } - ${ otherProps.data.isParent ? 'Parent' : 'Issuer' }` }
  </ReactSelectComponents.MultiValue>
);

export default MultiValueParentIssuerList;
